module.exports = __webpack_public_path__ + "media/react/assets/images/logo-small-7505b327b558bcc4d29c81d977d4a50b.svg";